import { connect } from 'react-redux';
import RadioGroup from './radio_group';

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  {}
)(RadioGroup);
